import { Link } from 'react-router-dom';

function SiteFooter() {
  return (
    <footer className="site-footer" aria-label="Footer">
      <div className="site-footer-main">
        <section className="site-footer-col">
          <h3>Get In Touch</h3>
          <p>Have a question about stock, finance, or part exchange?</p>
          <div className="site-footer-contact-row">
            <address className="site-footer-address">
              M.J. Motors
              <br />
              Summerbank Service Station
              <br />
              High Street
              <br />
              Stoke-on-Trent
              <br />
              Staffordshire
              <br />
              ST6 5ET
            </address>
            <div className="site-footer-contact-actions">
              <a className="site-footer-contact-link" href="tel:01782835561">
                <span className="site-footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
                    <path d="M6.7 3.9h2.8l1.3 4-1.8 1.6a15.5 15.5 0 0 0 5.5 5.5l1.6-1.8 4 1.3v2.8c0 .7-.6 1.3-1.3 1.3A15 15 0 0 1 4.1 5.2c0-.7.6-1.3 1.3-1.3Z" />
                  </svg>
                </span>
                01782 835561
              </a>
              <a className="site-footer-contact-link" href="mailto:markjeffery1000@yahoo.co.uk">
                <span className="site-footer-contact-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
                    <rect x="3.2" y="5.3" width="17.6" height="13.4" rx="1.8" />
                    <path d="m4.3 7 7.7 6 7.7-6" />
                  </svg>
                </span>
                Email Us
              </a>
            </div>
          </div>
        </section>

        <section className="site-footer-col">
          <h3>Opening Hours</h3>
          <div className="site-footer-hours" aria-label="Opening hours by day">
            <p><span>Monday</span><strong>09:00 - 17:30</strong></p>
            <p><span>Tuesday</span><strong>09:00 - 17:30</strong></p>
            <p><span>Wednesday</span><strong>09:00 - 17:30</strong></p>
            <p><span>Thursday</span><strong>09:00 - 17:30</strong></p>
            <p><span>Friday</span><strong>09:00 - 17:30</strong></p>
            <p><span>Saturday</span><strong>09:00 - 16:00</strong></p>
            <p><span>Sunday</span><strong>Closed</strong></p>
          </div>
        </section>

        <section className="site-footer-col">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/search">Showroom</Link>
          <Link to="/finance">Finance</Link>
          <Link to="/about-us">About Us</Link>
          <Link to="/contact">Contact</Link>
        </section>
      </div>

      <div className="site-footer-company">
        <p>
          VAT No. 78764868 Company No. 10685491 FCA No. 782628
        </p>
        <p>
          M.J. Motors is authorised and regulated by the Financial Conduct Authority, FRN: 782628. All finance is subject to status and income. Written Quotation on request. We act as a credit broker not a lender. We work with a number of carefully selected credit providers who may be able to offer you finance for your purchase. We are only able to offer finance products from these providers.
        </p>
      </div>
    </footer>
  );
}

export default SiteFooter;